import Request from './request';


async function fetch(data) {// 获取盘点计划单
    return Request('get', "api/shop-stock-take-plans/index" , data);
}

async function fetchOne(id) {// 获取盘点计划单详情
  return Request('get', "api/shop-stock-take-plans/view/" + id);
}

async function cancel(id){//作废盘点计划单
  return Request("delete",'api/shop-stock-take-plans/cancel/' + id)
}

async function settingShop(data) {//设置推送门店
  return Request('post', "api/shop-stock-take-plans/setting-shop", data);
}

async function statusUpdate(id){
  return Request("post",'api/shop-stock-take-plans/status-update/' + id)
}

async function add(data){
  return Request("post",'api/shop-stock-take-plans/add' , data)
}

async function detailCancel(id){
  return Request("delete",'api/shop-stock-take-plans/detail-cancel/' + id)
}

async function editPlan(data){
  return Request("post",'api/shop-stock-take-plans/edit-plan' , data)
}

export default {
  fetch,
  cancel,
  settingShop,
  statusUpdate,
  add,
  fetchOne,
  detailCancel,
  editPlan,
};